{
  "AddCRMTitle": "Aggiungi integrazione CRM",
  "ModififyCRMTitle": "Modifica l'integrazione CRM",
  "CRMDetailsTitle": "Dettagli",
  "CRMGeneralIDLabel": "ID",
  "CRMDetailsIDLabelPlaceholder": "[Assegnato automaticamente]",
  "CRMDetailsDescriptionLabel": "Descrizione",
  "CRMValidationDescriptionLabel": "La descrizione è obbligatoria",
  "NAME": "CRMModal",
  "CRMScopeTitle": "Ambito",
  "CRMConfigurationTitle": "Configurazione",
  "CRMConfigurationCRMTypeLabel": "CRM",
  "CRMConfigurationTypeNone": "Nessuno",
  "CRMConfigurationTab_Setting_Name": "Nome dell'impostazione",
  "CRMConfigurationTab_Value": "Valore"
}